import React from 'react';
import {
  Select,
  SelectProps,
  createStyles,
  withStyles,
  FormControl,
  OutlinedInput,
  MenuItem as MuiMenuItem,
  InputLabel,
  makeStyles,
} from '@material-ui/core';
import { primaryGreen } from 'src/data/colors';

const CustomInput = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ced4da',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ced4da',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: primaryGreen,
      borderWidth: 2,
    },
  },
}))(OutlinedInput);

const useStyles = makeStyles(() => ({
  label: {
    background:
      'linear-gradient(transparent 0%, transparent 33%, white 45%, white 64%, transparent 80%, transparent 100%)',
    padding: '0 1px',
    '&.Mui-focused': {
      color: primaryGreen,
    },
  },
}));

export const BaseSelect = withStyles(() =>
  createStyles({
    root: {
      width: '100%',
    },
  })
)((props: SelectProps) => {
  const classes = useStyles();

  return (
    <FormControl variant="outlined" size="small" fullWidth>
      {props.label && (
        <InputLabel id={props.labelId} className={classes.label}>
          {props.label}
        </InputLabel>
      )}
      <Select input={<CustomInput />} {...props} />
    </FormControl>
  );
}) as React.FC<SelectProps>;

export const MenuItem = withStyles(() => createStyles({}))(MuiMenuItem);
